import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import useI18n from '@i18n';

import Item from './Item';

export interface IDemandGroupProps {
    title: string;
    icon: IconDefinition;
    color: string;
    data: string[];
}

const DemandGroup: React.FC<IDemandGroupProps> = ({ title, icon, color, data }) => {
    const { t } = useI18n('Offers');

    return (
        <div className="py-3">
            <p className="mb-1 font-medium text-[14px] leading-[21px]" style={{ color }}>
                {t(title)}
            </p>
            <div className="flex flex-wrap">
                {data.map(item => {
                    return (
                        <div className="w-full max-w-full md:max-w-1/2 xl:max-w-1/3" key={item}>
                            <Item title={item} icon={icon} color={color} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DemandGroup;
